export default "__VITE_ASSET__18648f1f__"